module.exports = __webpack_public_path__ + "static/media/osu_logo.637f7054.png";